import { Action } from '@ngrx/store';
import { IDataCharts } from '../../common/models/IDataCharts';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { IQueueItem } from '../../common/models/IQueueItem';
import { IUipathJob } from '../../common/models/IUipathJob';

export enum EUIPathDashboardActions {
    getUIPathJobsList = '[UIPath Dashboard] List of Jobs',
    getUIPathJobsListSuccess = '[UIPath Dashboard] List of Jobs Success',
    getUIPathQueueitemsList = '[UIPath Dashboard] List of queueitems',
    getUIPathQueueitemsSuccess = '[UIPath Dashboard] List of queueitems Success',
    UIPathRetryJob = '[UIPath Dashboard] Retry UiPath Job',
    UIPathRetryQueueitem = '[UIPath Dashboard] Retry UiPath Queueitem',
    UIPathRetryQueueitemSuccess = '[UIPath Dashboard] Retry UiPath Queueitem success',
    getUIPathJobsData = '[UIPath Dashboard] Get UiPath data Jobs for charts',
    getUIPathJobsDataSuccess = '[UIPath Dashboard] Get UiPath data Jobs for charts Success',
    getUIPathQueueitemsData = '[UIPath Dashboard] Get UiPath data Queueitens for charts ',
    getUIPathQueueitemsDataSuccess = '[UIPath Dashboard] Get UiPath data Queueitens for charts Success',
    resetDashboard = '[UIPath Dashboard] Reset UiPath dashboard',
    resetRetries =  '[UIPath Dashboard] Reset UiPath retries',
    UIPathJobRetrySuccess = '[UIPath Dashboard] UiPath job restarted correctly',
    UIPathResetJobRetry = '[UIPath Dashboard] UiPath job id cleared',
    UIPathResetQueueitemRetry ='[UIPath Dashboard] UiPath Queueitem id cleared',
    UIPathErrorHandler = '[UiPath Dashboard] error handling',
    UIPathResetErrorHandler = '[UiPath Dashboard] error reset handling'
}

export class resetDashboard implements Action {
  public readonly type = EUIPathDashboardActions.resetDashboard;
}

export class resetRetries implements Action {
  public readonly type = EUIPathDashboardActions.resetRetries;
}

export class getUIPathJobsList implements Action {
  public readonly type = EUIPathDashboardActions.getUIPathJobsList;
  constructor(public payload: any) {}
}

export class getUIPathJobsListSuccess implements Action {
  public readonly type = EUIPathDashboardActions.getUIPathJobsListSuccess;
  constructor(public payload: IODataResponse<IUipathJob[]>) {}
}

export class UIPathJobRetrySuccess implements Action {
  public readonly type = EUIPathDashboardActions.UIPathJobRetrySuccess;
  constructor(public payload: any) {}
}

export class UIPathResetJobRetry implements Action {
  public readonly type = EUIPathDashboardActions.UIPathResetJobRetry;
}

export class UIPathResetQueueitemRetry implements Action {
  public readonly type = EUIPathDashboardActions.UIPathResetQueueitemRetry;
}

export class getUIPathQueueitemsList implements Action {
  public readonly type = EUIPathDashboardActions.getUIPathQueueitemsList;
  constructor(public payload: any) {}
}

export class getUIPathQueueitemsListSuccess implements Action {
    public readonly type = EUIPathDashboardActions.getUIPathQueueitemsSuccess;
    constructor(public payload: IODataResponse<IQueueItem[]>) {}
  }

export class UIPathRetryJob implements Action {
  public readonly type = EUIPathDashboardActions.UIPathRetryJob;
  constructor(public payload: any) {}
}


export class UIPathRetryQueueitem implements Action {
  public readonly type = EUIPathDashboardActions.UIPathRetryQueueitem;
  constructor(public payload: any) {}
}

export class UIPathRetryQueueitemSuccess implements Action {
  public readonly type = EUIPathDashboardActions.UIPathRetryQueueitemSuccess;
  constructor(public payload: any) {}
}

export class getUIPathJobsData implements Action {
  public readonly type = EUIPathDashboardActions.getUIPathJobsData;
  constructor(public payload: IRpaConnectionUiPath) {}
}

export class getUIPathJobsDataSuccess implements Action {
    public readonly type = EUIPathDashboardActions.getUIPathJobsDataSuccess;
    constructor(public payload: IDataCharts) {}
}

export class getUIPathQueueitemsData implements Action {
  public readonly type = EUIPathDashboardActions.getUIPathQueueitemsData;
  constructor(public payload: IRpaConnectionUiPath) {}
}

export class getUIPathQueueitemsDataSuccess implements Action {
    public readonly type = EUIPathDashboardActions.getUIPathQueueitemsDataSuccess;
    constructor(public payload: IDataCharts) {}
}

export class UIPathErrorHandler implements Action {
    public readonly type = EUIPathDashboardActions.UIPathErrorHandler;
}

export class UIPathResetErrorHandler implements Action {
  public readonly type = EUIPathDashboardActions.UIPathResetErrorHandler;
}

export type UIPathDashboardActions =
  | getUIPathJobsList
  | getUIPathJobsListSuccess
  | getUIPathQueueitemsList
  | getUIPathQueueitemsListSuccess
  | UIPathRetryJob
  | UIPathRetryQueueitem
  | UIPathRetryQueueitemSuccess
  | getUIPathJobsData
  | getUIPathJobsData
  | getUIPathJobsDataSuccess
  | getUIPathQueueitemsData
  | getUIPathQueueitemsDataSuccess
  | resetDashboard
  | UIPathResetJobRetry
  | UIPathResetQueueitemRetry
  | UIPathJobRetrySuccess
  | UIPathErrorHandler
  | UIPathResetErrorHandler
  | resetRetries
;
